import React from 'react';

import styles from './Times.module.scss';

const Times = (props) => {
  function isOdd(num) {
    let number = num % 2;
    return number === 1 ? true : false
  }

  return(
    <div className={styles.Times}>
      {props.times.map((time, i) =>
        <div key={i} className={styles.Time}>
          <div className={`${isOdd(i) ? styles.timeRight : styles.timeLeft} time`}>
            {time.time}
          </div>
          <img src={time.image.file.url} alt={time.image.title} className={`times-image`}/>
          <h3>{time.title}</h3>
          <p>{time.text.text}</p>
        </div>
      )}
    </div>
  )
}

export default Times;



// WEBPACK FOOTER //
// ./src/components/DayInTheLife/Times/index.js